import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const DevelopProjectPlanView = (props) => {
    const classes = props.classes;
    // Validation messages
    // Project Plan
    const uniqueSellingPointError = props.validationErrors.uniqueSellingPoint.show;
    const uniqueSellingPointHelperText = props.validationErrors.uniqueSellingPoint.show ? props.validationErrors.uniqueSellingPoint.errorMessage : '';
    const targetMarketError = props.validationErrors.targetMarket.show;
    const targetMarketHelperText = props.validationErrors.targetMarket.show ? props.validationErrors.targetMarket.errorMessage : '';
    const competitorsError = props.validationErrors.competitors.show;
    const competitorsHelperText = props.validationErrors.competitors.show ? props.validationErrors.competitors.errorMessage : '';
    const scopeOfWorkError = props.validationErrors.scopeOfWork.show;
    const scopeOfWorkHelperText = props.validationErrors.scopeOfWork.show ? props.validationErrors.scopeOfWork.errorMessage : '';


    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <form name="trading-online-voucher-scheme-2020">    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="projectPlan">
                                PROJECT PLAN
                            </h3>
                        </CardHeader>
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="uniqueSellingPoint">
                                Unique Selling Point(s)&nbsp;
                                {props.validationErrors.uniqueSellingPoint.check === null ? ' ' : (props.validationErrors.uniqueSellingPoint.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>Unique Selling Point of your Products / Services / Business.</p>
                                                    <p>Look at your online competitors, decide what products / services you will focus on - not all of them need to be traded online.</p>
                                                    <p>Why did you select what you have?</p>
                                                    <p>Try to think of things that make you unique in your industry or your local service area.</p>
                                                    <p>These should be convincing reasons for potential customers to choose your business rather than another.</p>
                                                    <p>The information should explain how your products or services can:</p>
                                                    <ul>
                                                        <li>solve customers problems</li>
                                                        <li>improves customers situations</li>
                                                        <li>delivers a specific benefit</li>
                                                    </ul>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='uniqueSellingPointInput'
                                        helperText={uniqueSellingPointHelperText}
                                        error={uniqueSellingPointError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'uniqueSellingPoint',
                                            value: props.uniqueSellingPoint,
                                            onChange: props.handleUniqueSellingPoint,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'magic']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h4 className={classes.title} id="targetMarket">
                                Your Target Market Through This Project&nbsp;
                                {props.validationErrors.targetMarket.check === null ? ' ' : (props.validationErrors.targetMarket.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>Who are your customers going to be? (i.e. what customers will you target through your online channels?)</p>
                                                    <p>It will look well for businesses selling products to target new customers beyond the locations of your current customer base, ideally outside of Ireland. In most cases, the UK is the ideal first step into international trading.</p>
                                                    <p>For local or service-based businesses, global expansion is likely to be a stretch. However, it is essential to identify potential new customer categories or adjacent markets to what you currently have.</p>
                                                    <p>You can look at your current customers and see if they fit into specific groups, such as young, old, domestic, industrial etc. Then see if you can find similar groups of customers in other markets.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='targetMarketInput'
                                        helperText={targetMarketHelperText}
                                        error={targetMarketError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'targetMarket',
                                            value: props.targetMarket,
                                            onChange: props.handleTargetMarket,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'bullseye']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h4 className={classes.title} id="competitors">
                                Trading Online Competitors&nbsp;
                                {props.validationErrors.competitors.check === null ? ' ' : (props.validationErrors.competitors.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>When you use a search engine online to look for your company's product/services, what companies/sites are displayed? (list 3 to 5 with a link to their websites).</p>
                                                    <p>Look to find the competitors that most closely match your business regarding products, services and target market.</p>
                                                    <p>Only listing several websites may suffice, depending on the strength of your overall application.</p>
                                                    <p>However, it may help your application if you add any note-worthy remarks about your competitors. For example, how you may learn from them or how you may have a business advantage.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='competitorsInput'
                                        helperText={competitorsHelperText}
                                        error={competitorsError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'competitors',
                                            value: props.competitors,
                                            onChange: props.handleCompetitors,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'chess']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h4 className={classes.title} id="scopeOfWork">
                                Scope Of Work To Be Carried Out&nbsp;
                                {props.validationErrors.scopeOfWork.check === null ? ' ' : (props.validationErrors.scopeOfWork.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>What are the specific deliverables of the project relating to the business objectives?</p>
                                                    <p>You need to describe the work to be undertaken in this project.</p>
                                                    <p>This section is one of the critical criteria on which your application will be judged. It's essential to give as much information as possible.</p>
                                                    <p>Your chosen supplier(s) should supply you with the precise details needed for this section.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='scopeOfWorkInput'
                                        helperText={scopeOfWorkHelperText}
                                        error={scopeOfWorkError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'scopeOfWork',
                                            value: props.scopeOfWork,
                                            onChange: props.handleScopeOfWork,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'laptop-house']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_PROJECT}>
                                    &lt; Project Description 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_INVEST}>
                                    Business Investment &gt; 
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

DevelopProjectPlanView.propTypes = {
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // Project Plan
    handleUniqueSellingPoint: PropTypes.func.isRequired,
    handleTargetMarket: PropTypes.func.isRequired,
    handleCompetitors: PropTypes.func.isRequired,
    handleScopeOfWork: PropTypes.func.isRequired,
    validationErrors: PropTypes.object.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(DevelopProjectPlanView));